export enum LearningMaterialEnum {
  DRAFT = 0,
  APPROVAL_WAIT = 1,
  APPROVED = 2,
  APPROVAL_DENIED = 3,
  UPDATE = 4,
}

export enum EnrollClassEnum {
  NOT_YET_OPEN = 10,
  ENROLLING = 20,
  CLOSED_ENROLLING = 30,
  OPENED = 40,
  CLOSED = 50,
}
